import React, { Component } from 'react';
import Page from '../../components/page';
import { push } from 'react-router-redux';
import './schools.scss';
import { frontloadConnect } from 'react-frontload';
import { connect } from 'react-redux';
import { getSchools } from '../../reducers';
import { linkService } from '../';
import { getArrayOf } from '../../utils';
import Helmet from 'react-helmet';
import NotFound from '../not-found';

const categoriesIds = ['ING', 'BUS', 'SCP', 'ENS', 'OTH'];
const categories = {
  ING: {
    title: "Écoles d'Ingénieurs",
    schools: {},
    index: 1
  },
  BUS: {
    title: 'Écoles de Commerce',
    schools: {},
    index: 2
  },
  SCP: {
    title: 'Sciences Po',
    schools: {},
    index: 3
  },
  ENS: {
    title: 'Ecoles Normales supérieures',
    schools: {},
    index: 4
  },
  OTH: {
    title: 'Autres',
    schools: {},
    index: 5
  }
};

const frontload = async props => await props.getSchools();

export class Schools extends Component {
  render() {
    const { schools } = this.props;

    return (
      <Helmet title="Not Found">
        <meta name="robots" content="noindex" />
      </Helmet>
    )
    return (
      <Page id="schools" title={'Ecoles | Clevermate'}>
        <div className="steps-block" id="ecoles">
          <div className="container">
            <div className="steps-wrap red">
              <h1 className="single-step">
                <b>
                  Recrutez, en professeur particulier, un étudiant des
                  meilleures écoles francaises
                </b>
              </h1>

              <div className="single-step-text no-background">
                <h2 className="single-step">
                  Clevermate sélectionne ses étudiants dans les filières
                  d'excellence académiques.
                  <br /> En fonction de leur cursus les étudiants seront à même
                  de dispenser des cours de soutien scolaire dans différentes
                  matières.
                  <br />
                </h2>
              </div>
              {categoriesIds.map(id => (
                <div className="single-step" key={id}>
                  <h4>{categories[id].title}</h4>
                  <div className="single-step-text">
                    {schools.length
                      ? schools
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map(school => (
                            <p key={school.slug}>
                              <a
                                href={linkService.getSchoolPath(school.slug)}
                                onClick={event => {
                                  event.preventDefault();
                                  this.props.goTo(
                                    linkService.getSchoolPath(school.slug)
                                  );
                                }}
                              >
                                {school.name}
                              </a>
                            </p>
                          ))
                      : SkeletonSchools({ number: 15 })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Page>
    );
  }
}

const SkeletonSchools = ({ number }) => (
  <div>
    {getArrayOf(number).map((value, index) => (
      <p key={index}>
        <a
          className={index % 2 === 0 ? 'skeleton-line-40' : 'skeleton-line-60'}
          style={{ display: 'inline-block', marginBottom: 5 }}
        />
      </p>
    ))}
  </div>
);

const mapStateToProps = state => ({
  schools: state.school.schools
});

const mapDispatchToProps = dispatch => ({
  getSchools: () => {
    dispatch(getSchools());
  },
  goTo: path => {
    dispatch(push(path));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false
  })(Schools)
);
